import React from "react";
import { Image } from "semantic-ui-react";

import logo from "../../assets/logo.png";
import style from "./style.module.css";

export default function Logo() {
  return <Image className={style.logo} size="medium" centered src={logo} />;
}
